import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";

import { useAppSelector } from "../../redux/hooks";

const ShopifyRedirector = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const history = useHistory();
  const queryParams = new URLSearchParams(history.location.search);
  if (!isAuthenticated) {
    const redirectUri = encodeURIComponent(`/user/apps/shopify?${queryParams.toString()}`);
    history.replace(`/?redirect=${redirectUri}`);
  } else {
    history.replace(`/user/apps/shopify?${queryParams.toString()}`);
  }
  return null;
};

const Shopify = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${path}/install`}>
        <ShopifyRedirector />
      </Route>
    </Switch>
  );
};

export default Shopify;
